export default __webpack_public_path__ + "static/media/Morph Choleric Fiend.4337bb05.jpg";